import React from 'react';
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import {ButtonToolbar} from "react-bootstrap";

export default class PokazNaMapie extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            center: (Boolean(this.props.przystanek.dlGps) && Boolean(this.props.przystanek.szGps)) ? {
                lat: this.props.przystanek.szGps,
                lng: this.props.przystanek.dlGps
            } : {lat: 50.04, lng: 22},
            zoom: 12,
            mapTypeId: 'roadmap',
            lat: null,
            lng: null
        };
        this.getMap = this.getMap.bind(this)
        this.onPokazPrzystanek = this.onPokazPrzystanek.bind(this)
    }

    componentDidMount() {
        let map = this.getMap();
        if (Boolean(this.props.przystanek)) {
            let latlng = {lat: this.props.przystanek.szGps, lng: this.props.przystanek.dlGps}

            if (Boolean(this.props.przystanek.dlGps) && Boolean(this.props.przystanek.szGps)) {
                this.onPokazPrzystanek(latlng)
            }
        }
    }

    componentWillReceiveProps(nextprops){
        if (Boolean(nextprops.przystanek)) {
            let latlng = {lat: nextprops.przystanek.szGps, lng: nextprops.przystanek.dlGps}

            if (Boolean(nextprops.przystanek.dlGps) && Boolean(nextprops.przystanek.szGps)) {
                this.onPokazPrzystanek(latlng)
            }
        }
    }

    getMap() {

        let map = new window.google.maps.Map(document.getElementById('map'), {
            center: this.state.center,
            zoom: this.state.zoom,
            mapTypeId: this.state.mapTypeId,
        });

        map.addListener('zoom_changed', () => {
            this.setState({
                zoom: map.getZoom()
            });
        });

        map.addListener('maptypeid_changed', () => {
            this.setState({
                mapTypeId: map.getMapTypeId(),
            });
        });

        return map
    }

    setMarker(wspolrzedne) {
        let marker = new window.google.maps.Marker({
            map: this.getMap(),
            position: wspolrzedne
        })
    }

    onPokazPrzystanek(wspolrzedne) {
        this.setMarker(null)
        this.setState({center: wspolrzedne})
        this.getMap().setCenter(wspolrzedne)
        this.setMarker(wspolrzedne)
    }

    render() {
        return (
            <div>
                <div>
                    <div className={'pull-right'} style={{marginBottom: '5px'}}>
                        <ButtonToolbar>
                            <TopButtonAction onClick={() => {
                                this.props.handleZamknijMape()
                            }} btnColor={'default'} iconType={'fa fa-times'} btnSize={'medium'} text={'Zamknij mapę'}/>
                        </ButtonToolbar>
                    </div>
                </div>
                <div style={{clear: 'both'}}>
                    <div id='map' style={{height: '50vh'}}/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/przystanki/googleMapComponents/PokazNaMapie.js